import { lazy } from 'react';
import { ROUTES } from './constants';

// Lazy load components with descriptive names
const HomePage = lazy(() => import('../app/page'));
const UpcomingPage = lazy(() => import('../app/upcoming/page'));
const TradingPage = lazy(() => import('../app/trading/page'));
const TradingMemePage = lazy(() => import('../app/trading-meme/page'));
const DefaiTradingPage = lazy(() => import('../app/trading-defai/page'));
const CreateTokenPage = lazy(() => import('../app/create-coin/page'));
const MemePage = lazy(() => import('../app/meme/page'));
const ProfilePage = lazy(() => import('../app/profile/page'));
const StrongBoxVaultPage = lazy(() => import('../app/strongbox-vault/page'));
const MaxUtilitiesPage = lazy(() => import('../app/max-utilities/page'));

/**
 * Route configuration with path and component mapping
 */
export const routeConfig = [
  {
    path: ROUTES.HOME,
    component: HomePage,
    exact: true,
  },
  {
    path: ROUTES.MEME,
    component: MemePage,
    exact: true,
  },
  {
    path: ROUTES.CREATE_COIN,
    component: CreateTokenPage,
    exact: true,
  },
  {
    path: ROUTES.VAULTS,
    component: StrongBoxVaultPage,
    exact: true,
  },
  {
    path: ROUTES.MAX_UTILITIES,
    component: MaxUtilitiesPage,
    exact: true,
  },
  {
    path: ROUTES.PROFILE,
    component: ProfilePage,
    exact: true,
  },
  {
    path: ROUTES.UPCOMING,
    component: UpcomingPage,
    exact: true,
  },
  {
    path: ROUTES.TRADING,
    component: TradingPage,
    exact: true,
  },
  {
    path: ROUTES.TRADING_MEME,
    component: TradingMemePage,
    exact: true,
  },
  {
    path: ROUTES.TRADING_DEFAI,
    component: DefaiTradingPage,
    exact: true,
  },
];
